




























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Througoutput extends Vue {
  @Prop() value!: string|null;
  private showDialog = false;


  get messages() {
    return this.value?.split('/')[0] ?? 0
  }

  set messages(val) {
    this.value = (val ?? 0) + '/' + this.times
    this.$emit('input',this.value);
  }

  get times() {
    return this.value?.split('/')[1] ?? 1
  }

  set times(val) {
    this.value = this.messages + '/' + (val ?? 1)
    this.$emit('input',this.value);
  }
}
